export interface QuestionMapping {
  id: string;
  title: string;
  description?: string;
  type: 'main' | 'sub' | 'followup';
  parentId?: string;
  category?: 'zero-examples' | 'one-examples' | 'behavior-questions' | 'hearing-test' | 'pretend-play' | 'climbing-activities' | 'finger-movements' | 'frequency-check' | 'pointing-behaviors' | 'show-me-question' | 'imitation-behaviors' | 'additional-checks' | 'interest-check' | 'social-behaviors' | 'response-check' | 'followup-question' | 'sharing-behaviors' | 'sharing-followup' | 'positive-responses' | 'negative-responses' | 'positive-behaviors' | 'negative-behaviors' | 'noise-sensitivity' | 'walking-behaviors' | 'eye-contact-behaviors' | 'eye-contact-followup' | 'copying-behaviors' | 'attention-seeking-behaviors' | 'command-understanding-with-clues' | 'command-understanding-without-clues' | 'social-referencing-behaviors' | 'movement-enjoyment' | 'movement-reactions';
}

export const QuestionMapping: Record<string, QuestionMapping> = {
  // Question 1
  'Q1': {
    id: 'Q1',
    title: 'Q1: If you point at something across the room, does your child look at it?',
    description: 'if you point at a toy or an animal, does your child look at the toy or animal?',
    type: 'main'
  },
  'Q1.1.1': {
    id: 'Q1.1.1',
    title: 'Look at object?',
    type: 'sub',
    parentId: 'Q1',
    category: 'zero-examples'
  },
  'Q1.1.2': {
    id: 'Q1.1.2',
    title: 'Point to object?',
    type: 'sub',
    parentId: 'Q1',
    category: 'zero-examples'
  },
  'Q1.1.3': {
    id: 'Q1.1.3',
    title: 'Look and comment on object?',
    type: 'sub',
    parentId: 'Q1',
    category: 'zero-examples'
  },
  'Q1.1.4': {
    id: 'Q1.1.4',
    title: 'Look if you point and say "look!"?',
    type: 'sub',
    parentId: 'Q1',
    category: 'zero-examples'
  },
  'Q1.2.1': {
    id: 'Q1.2.1',
    title: 'Ignores you?',
    type: 'sub',
    parentId: 'Q1',
    category: 'one-examples'
  },
  'Q1.2.2': {
    id: 'Q1.2.2',
    title: 'Look around room randomly?',
    type: 'sub',
    parentId: 'Q1',
    category: 'one-examples'
  },
  'Q1.2.3': {
    id: 'Q1.2.3',
    title: 'Look at your finger?',
    type: 'sub',
    parentId: 'Q1',
    category: 'one-examples'
  },
  'Q1.3': {
    id: 'Q1.3',
    title: 'Most Often',
    type: 'followup',
    parentId: 'Q1'
  },

  // Question 2
  'Q2': {
    id: 'Q2',
    title: 'Q2: Have you ever wondered if your child might be deaf?',
    description: 'You reported that you have wondered if you child is deaf. What led you to wonder that?',
    type: 'main'
  },
  'Q2.1': {
    id: 'Q2.1',
    title: 'Often ignore sounds?',
    type: 'sub',
    parentId: 'Q2',
    category: 'behavior-questions'
  },
  'Q2.2': {
    id: 'Q2.2',
    title: 'Often ignore people?',
    type: 'sub',
    parentId: 'Q2',
    category: 'behavior-questions'
  },
  'Q2.3': {
    id: 'Q2.3',
    title: 'Hearing tested?',
    type: 'sub',
    parentId: 'Q2',
    category: 'hearing-test'
  },
  'Q2.3.1': {
    id: 'Q2.3.1',
    title: 'Hearing results',
    type: 'followup',
    parentId: 'Q2.3',
    category: 'hearing-test'
  },

  // Question 3
  'Q3': {
    id: 'Q3',
    title: 'Q3: Does your child play pretend or make-believe?',
    description: 'pretend to drink from an empty cup, pretend to talk on a phone, or pretend to feed a doll or stuffed animal?)',
    type: 'main'
  },
  'Q3.1.1': {
    id: 'Q3.1.1',
    title: 'Pretend to drink from a toy cup?',
    type: 'sub',
    parentId: 'Q3',
    category: 'pretend-play'
  },
  'Q3.1.2': {
    id: 'Q3.1.2',
    title: 'Pretend to eat from a toy spoon or fork?',
    type: 'sub',
    parentId: 'Q3',
    category: 'pretend-play'
  },
  'Q3.1.3': {
    id: 'Q3.1.3',
    title: 'Pretend to talk on the telephone?',
    type: 'sub',
    parentId: 'Q3',
    category: 'pretend-play'
  },
  'Q3.1.4': {
    id: 'Q3.1.4',
    title: 'Pretend to feed a doll or stuffed animal with real or imaginary food?',
    type: 'sub',
    parentId: 'Q3',
    category: 'pretend-play'
  },
  'Q3.1.5': {
    id: 'Q3.1.5',
    title: 'Push a car as if it is going along a pretend road?',
    type: 'sub',
    parentId: 'Q3',
    category: 'pretend-play'
  },
  'Q3.1.6': {
    id: 'Q3.1.6',
    title: 'Pretend to be a robot, an airplane, a ballerina, or any other favorite character?',
    type: 'sub',
    parentId: 'Q3',
    category: 'pretend-play'
  },
  'Q3.1.7': {
    id: 'Q3.1.7',
    title: 'Put a toy pot on a pretend stove?',
    type: 'sub',
    parentId: 'Q3',
    category: 'pretend-play'
  },
  'Q3.1.8': {
    id: 'Q3.1.8',
    title: 'Stir imaginary food?',
    type: 'sub',
    parentId: 'Q3',
    category: 'pretend-play'
  },
  'Q3.1.9': {
    id: 'Q3.1.9',
    title: 'Put an action figure or doll into a car or truck as if it is the driver or passenger?',
    type: 'sub',
    parentId: 'Q3',
    category: 'pretend-play'
  },
  'Q3.1.10': {
    id: 'Q3.1.10',
    title: 'Pretend to vacuum the rug, sweep the floor, or mow the lawn?',
    type: 'sub',
    parentId: 'Q3',
    category: 'pretend-play'
  },

  // Question 4
  'Q4': {
    id: 'Q4',
    title: 'Q4: Does your child like climbing on things?',
    description: 'furniture, playground equipment, or stairs',
    type: 'main'
  },
  'Q4.1.1': {
    id: 'Q4.1.1',
    title: 'Stairs?',
    type: 'sub',
    parentId: 'Q4',
    category: 'climbing-activities'
  },
  'Q4.1.2': {
    id: 'Q4.1.2',
    title: 'Chairs?',
    type: 'sub',
    parentId: 'Q4',
    category: 'climbing-activities'
  },
  'Q4.1.3': {
    id: 'Q4.1.3',
    title: 'Furniture?',
    type: 'sub',
    parentId: 'Q4',
    category: 'climbing-activities'
  },
  'Q4.1.4': {
    id: 'Q4.1.4',
    title: 'Playground equipment?',
    type: 'sub',
    parentId: 'Q4',
    category: 'climbing-activities'
  },

  // Question 5
  'Q5': {
    id: 'Q5',
    title: 'Q5: Does your child make unusual finger movements near his or her eyes?',
    description: '(FOR EXAMPLE, does your child wiggle his or her fingers close to his or her eyes?)',
    type: 'main'
  },
  'Q5.1.1': {
    id: 'Q5.1.1',
    title: 'Look at hands?',
    type: 'sub',
    parentId: 'Q5',
    category: 'finger-movements'
  },
  'Q5.1.2': {
    id: 'Q5.1.2',
    title: 'Moves finger when playing peek-a-boo?',
    type: 'sub',
    parentId: 'Q5',
    category: 'finger-movements'
  },
  'Q5.2.1': {
    id: 'Q5.2.1',
    title: 'Wiggle his/her fingers near his/her eyes?',
    type: 'sub',
    parentId: 'Q5',
    category: 'finger-movements'
  },
  'Q5.2.2': {
    id: 'Q5.2.2',
    title: 'Hold his/her hands up close to his/her eyes?',
    type: 'sub',
    parentId: 'Q5',
    category: 'finger-movements'
  },
  'Q5.2.3': {
    id: 'Q5.2.3',
    title: 'Hold his/her hands off to the side of his/her eyes?',
    type: 'sub',
    parentId: 'Q5',
    category: 'finger-movements'
  },
  'Q5.2.4': {
    id: 'Q5.2.4',
    title: 'Flap his/her hands near his/her face?',
    type: 'sub',
    parentId: 'Q5',
    category: 'finger-movements'
  },
  'Q5.3': {
    id: 'Q5.3',
    title: 'Does this happen more than twice a week?',
    type: 'followup',
    parentId: 'Q5'
  },

  // Question 6
  'Q6': {
    id: 'Q6',
    title: 'Q6: Does your child point with one finger to ask for something or to get help?',
    description: 'pointing to a snack or toy that is out of reach',
    type: 'main'
  },
  'Q6.1.1': {
    id: 'Q6.1.1',
    title: 'Reach for the object with his/her whole hand?',
    type: 'sub',
    parentId: 'Q6',
    category: 'pointing-behaviors'
  },
  'Q6.1.2': {
    id: 'Q6.1.2',
    title: 'Lead you to the object?',
    type: 'sub',
    parentId: 'Q6',
    category: 'pointing-behaviors'
  },
  'Q6.1.3': {
    id: 'Q6.1.3',
    title: 'Try to get the object for him/herself?',
    type: 'sub',
    parentId: 'Q6',
    category: 'pointing-behaviors'
  },
  'Q6.1.4': {
    id: 'Q6.1.4',
    title: 'Ask for it using words or sounds?',
    type: 'sub',
    parentId: 'Q6',
    category: 'pointing-behaviors'
  },
  'Q6.2': {
    id: 'Q6.2',
    title: 'If you said "Show me," would he/she point at it?',
    type: 'followup',
    parentId: 'Q6',
    category: 'show-me-question'
  },

  // Question 7
  'Q7': {
    id: 'Q7',
    title: 'Q7: Does your child point with one finger to show you something interesting?',
    description: 'Please give me an example of something your child might point at to show you.',
    type: 'main'
  },
  'Q7.1.1': {
    id: 'Q7.1.1',
    title: 'An airplane in the sky?',
    type: 'sub',
    parentId: 'Q7',
    category: 'imitation-behaviors'
  },
  'Q7.1.2': {
    id: 'Q7.1.2',
    title: 'A truck on the road?',
    type: 'sub',
    parentId: 'Q7',
    category: 'imitation-behaviors'
  },
  'Q7.1.3': {
    id: 'Q7.1.3',
    title: 'A bug on the ground?',
    type: 'sub',
    parentId: 'Q7',
    category: 'imitation-behaviors'
  },
  'Q7.1.4': {
    id: 'Q7.1.4',
    title: 'An animal in the yard?',
    type: 'sub',
    parentId: 'Q7',
    category: 'imitation-behaviors'
  },
  'Q7.2': {
    id: 'Q7.2',
    title: 'How does your child draw your attention to it? Would he/she point with one finger?',
    type: 'followup',
    parentId: 'Q7',
    category: 'additional-checks'
  },
  'Q7.3': {
    id: 'Q7.3',
    title: 'Is this to show his interest, not to get help?',
    type: 'followup',
    parentId: 'Q7',
    category: 'additional-checks'
  },

  // Question 8
  'Q8': {
    id: 'Q8',
    title: 'Q8: Is your child interested in other children?',
    description: 'does your child watch other children, smile at them, or go to them?)',
    type: 'main'
  },
  'Q8.1': {
    id: 'Q8.1',
    title: 'When you are at the playground or supermarket, does your child usually respond to other children?',
    type: 'followup',
    parentId: 'Q8',
    category: 'followup-question'
  },
  'Q8.1.1': {
    id: 'Q8.1.1',
    title: 'Is he/she interested in children who are not his/her brother or sister?',
    type: 'sub',
    parentId: 'Q8',
    category: 'interest-check'
  },
  'Q8.2.1': {
    id: 'Q8.2.1',
    title: 'Play with another child?',
    type: 'sub',
    parentId: 'Q8',
    category: 'social-behaviors'
  },
  'Q8.2.2': {
    id: 'Q8.2.2',
    title: 'Talk to another child?',
    type: 'sub',
    parentId: 'Q8',
    category: 'social-behaviors'
  },
  'Q8.2.3': {
    id: 'Q8.2.3',
    title: 'Babble or make vocal noises?',
    type: 'sub',
    parentId: 'Q8',
    category: 'social-behaviors'
  },
  'Q8.2.4': {
    id: 'Q8.2.4',
    title: 'Watch another child?',
    type: 'sub',
    parentId: 'Q8',
    category: 'social-behaviors'
  },
  'Q8.2.5': {
    id: 'Q8.2.5',
    title: 'Smile at another child?',
    type: 'sub',
    parentId: 'Q8',
    category: 'social-behaviors'
  },
  'Q8.2.6': {
    id: 'Q8.2.6',
    title: 'Act shy at first but then smile?',
    type: 'sub',
    parentId: 'Q8',
    category: 'social-behaviors'
  },
  'Q8.2.7': {
    id: 'Q8.2.7',
    title: 'Get excited about another child?',
    type: 'sub',
    parentId: 'Q8',
    category: 'social-behaviors'
  },
  'Q8.3': {
    id: 'Q8.3',
    title: 'Does he/she respond to other children more than half of the time?',
    type: 'followup',
    parentId: 'Q8',
    category: 'response-check'
  },
  'Q8.3.1': {
    id: 'Q8.3.1',
    title: 'Does he/she respond to other children more than half of the time?',
    type: 'followup',
    parentId: 'Q8',
    category: 'response-check'
  },

  // Question 9
  'Q9': {
    id: 'Q9',
    title: 'Q9: Does your child show you things by bringing them to you or holding them up for you to see? Not just to get help, but to share?',
    type: 'main'
  },
  'Q9.1.1': {
    id: 'Q9.1.1',
    title: 'A picture or toy just to show you?',
    type: 'sub',
    parentId: 'Q9',
    category: 'sharing-behaviors'
  },
  'Q9.1.2': {
    id: 'Q9.1.2',
    title: 'A drawing he/she has done?',
    type: 'sub',
    parentId: 'Q9',
    category: 'sharing-behaviors'
  },
  'Q9.1.3': {
    id: 'Q9.1.3',
    title: 'A flower he/she has picked?',
    type: 'sub',
    parentId: 'Q9',
    category: 'sharing-behaviors'
  },
  'Q9.1.4': {
    id: 'Q9.1.4',
    title: 'A bug he/she has found in the grass?',
    type: 'sub',
    parentId: 'Q9',
    category: 'sharing-behaviors'
  },
  'Q9.1.5': {
    id: 'Q9.1.5',
    title: 'A few blocks he/she has put together?',
    type: 'sub',
    parentId: 'Q9',
    category: 'sharing-behaviors'
  },
  'Q9.2': {
    id: 'Q9.2',
    title: 'Is this sometimes just to show you, not to get help?',
    type: 'followup',
    parentId: 'Q9',
    category: 'sharing-followup'
  },

  // Question 10
  'Q10': {
    id: 'Q10',
    title: 'Q10: Does your child respond when you call his or her name?',
    description: 'does he or she look up, talk or babble, or stop what he or she is doing when you call his or her name?)',
    type: 'main'
  },
  'Q10.1.1': {
    id: 'Q10.1.1',
    title: 'Look up?',
    type: 'sub',
    parentId: 'Q10',
    category: 'positive-responses'
  },
  'Q10.1.2': {
    id: 'Q10.1.2',
    title: 'Talk or babble?',
    type: 'sub',
    parentId: 'Q10',
    category: 'positive-responses'
  },
  'Q10.1.3': {
    id: 'Q10.1.3',
    title: 'Stop what he/she is doing?',
    type: 'sub',
    parentId: 'Q10',
    category: 'positive-responses'
  },
  'Q10.2.1': {
    id: 'Q10.2.1',
    title: 'Make no response?',
    type: 'sub',
    parentId: 'Q10',
    category: 'negative-responses'
  },
  'Q10.2.2': {
    id: 'Q10.2.2',
    title: 'Seem to hear but ignores parent?',
    type: 'sub',
    parentId: 'Q10',
    category: 'negative-responses'
  },
  'Q10.2.3': {
    id: 'Q10.2.3',
    title: 'Respond only if parent is right in front of the child\'s face?',
    type: 'sub',
    parentId: 'Q10',
    category: 'negative-responses'
  },
  'Q10.2.4': {
    id: 'Q10.2.4',
    title: 'Respond only if touched?',
    type: 'sub',
    parentId: 'Q10',
    category: 'negative-responses'
  },
  'Q10.3': {
    id: 'Q10.3',
    title: 'Does he/she respond to other children more than half of the time?',
    type: 'followup',
    parentId: 'Q10'
  },

  // Question 11
  'Q11': {
    id: 'Q11',
    title: 'Q11: When you smile at your child, does he or she smile back at you?',
    type: 'main'
  },
  'Q11.1.1': {
    id: 'Q11.1.1',
    title: 'Smile when you smile?',
    type: 'sub',
    parentId: 'Q11',
    category: 'positive-behaviors'
  },
  'Q11.1.2': {
    id: 'Q11.1.2',
    title: 'Smile when you enter the room?',
    type: 'sub',
    parentId: 'Q11',
    category: 'positive-behaviors'
  },
  'Q11.1.3': {
    id: 'Q11.1.3',
    title: 'Smile when you return from being away?',
    type: 'sub',
    parentId: 'Q11',
    category: 'positive-behaviors'
  },
  'Q11.2.1': {
    id: 'Q11.2.1',
    title: 'Always smile?',
    type: 'sub',
    parentId: 'Q11',
    category: 'negative-behaviors'
  },
  'Q11.2.2': {
    id: 'Q11.2.2',
    title: 'Smile at a favorite toy or activity?',
    type: 'sub',
    parentId: 'Q11',
    category: 'negative-behaviors'
  },
  'Q11.2.3': {
    id: 'Q11.2.3',
    title: 'Smile randomly or at nothing in particular?',
    type: 'sub',
    parentId: 'Q11',
    category: 'negative-behaviors'
  },
  'Q11.3': {
    id: 'Q11.3',
    title: 'Which type of behaviors does your child show most often?',
    type: 'followup',
    parentId: 'Q11'
  },

  // Question 12
  'Q12': {
    id: 'Q12',
    title: 'Q12: Does your child get upset by everyday noises?',
    description: 'does your child scream or cry to noise such as a vacuum cleaner or loud music?',
    type: 'main'
  },
  'Q12.1.1': {
    id: 'Q12.1.1',
    title: 'A washing machine?',
    type: 'sub',
    parentId: 'Q12',
    category: 'noise-sensitivity'
  },
  'Q12.1.2': {
    id: 'Q12.1.2',
    title: 'Babies crying?',
    type: 'sub',
    parentId: 'Q12',
    category: 'noise-sensitivity'
  },
  'Q12.1.3': {
    id: 'Q12.1.3',
    title: 'Vacuum cleaner?',
    type: 'sub',
    parentId: 'Q12',
    category: 'noise-sensitivity'
  },
  'Q12.1.4': {
    id: 'Q12.1.4',
    title: 'Hairdryer?',
    type: 'sub',
    parentId: 'Q12',
    category: 'noise-sensitivity'
  },
  'Q12.1.5': {
    id: 'Q12.1.5',
    title: 'Traffic?',
    type: 'sub',
    parentId: 'Q12',
    category: 'noise-sensitivity'
  },
  'Q12.1.6': {
    id: 'Q12.1.6',
    title: 'Babies squealing or screeching?',
    type: 'sub',
    parentId: 'Q12',
    category: 'noise-sensitivity'
  },
  'Q12.1.7': {
    id: 'Q12.1.7',
    title: 'Loud music?',
    type: 'sub',
    parentId: 'Q12',
    category: 'noise-sensitivity'
  },
  'Q12.1.8': {
    id: 'Q12.1.8',
    title: 'Telephone/doorbell ringing?',
    type: 'sub',
    parentId: 'Q12',
    category: 'noise-sensitivity'
  },
  'Q12.1.9': {
    id: 'Q12.1.9',
    title: 'Noisy places such as a supermarket or restaurant?',
    type: 'sub',
    parentId: 'Q12',
    category: 'noise-sensitivity'
  },
  'Q12.2.1': {
    id: 'Q12.2.1',
    title: 'Calmly cover his/her ears?',
    type: 'sub',
    parentId: 'Q12',
    category: 'positive-behaviors'
  },
  'Q12.2.2': {
    id: 'Q12.2.2',
    title: 'Tell you that he/she does not like the noise?',
    type: 'sub',
    parentId: 'Q12',
    category: 'positive-behaviors'
  },
  'Q12.3.1': {
    id: 'Q12.3.1',
    title: 'Scream?',
    type: 'sub',
    parentId: 'Q12',
    category: 'negative-behaviors'
  },
  'Q12.3.2': {
    id: 'Q12.3.2',
    title: 'Cry?',
    type: 'sub',
    parentId: 'Q12',
    category: 'negative-behaviors'
  },
  'Q12.3.3': {
    id: 'Q12.3.3',
    title: 'Cover his/her ears while upset?',
    type: 'sub',
    parentId: 'Q12',
    category: 'negative-behaviors'
  },
  'Q12.4': {
    id: 'Q12.4',
    title: 'Which type of behaviors does your child show most often?',
    type: 'followup',
    parentId: 'Q12'
  },

  // Question 13
  'Q13': {
    id: 'Q13',
    title: 'Q13: Does your child walk?',
    type: 'main'
  },
  'Q13.1': {
    id: 'Q13.1',
    title: 'Does he/she walk without holding on to anything?',
    type: 'followup',
    parentId: 'Q13',
    category: 'walking-behaviors'
  },

  // Question 14
  'Q14': {
    id: 'Q14',
    title: 'Q14: Does your child look you in the eye when you are talking to him or her, playing with him or her, or dressing him or her?',
    type: 'main'
  },
  'Q14.1.1': {
    id: 'Q14.1.1',
    title: 'When he/she needs something?',
    type: 'sub',
    parentId: 'Q14',
    category: 'eye-contact-behaviors'
  },
  'Q14.1.2': {
    id: 'Q14.1.2',
    title: 'When you are playing with him/her?',
    type: 'sub',
    parentId: 'Q14',
    category: 'eye-contact-behaviors'
  },
  'Q14.1.3': {
    id: 'Q14.1.3',
    title: 'During feeding?',
    type: 'sub',
    parentId: 'Q14',
    category: 'eye-contact-behaviors'
  },
  'Q14.1.4': {
    id: 'Q14.1.4',
    title: 'During diaper changes?',
    type: 'sub',
    parentId: 'Q14',
    category: 'eye-contact-behaviors'
  },
  'Q14.1.5': {
    id: 'Q14.1.5',
    title: 'When you are reading him/her a story?',
    type: 'sub',
    parentId: 'Q14',
    category: 'eye-contact-behaviors'
  },
  'Q14.1.6': {
    id: 'Q14.1.6',
    title: 'When you are talking to him/her?',
    type: 'sub',
    parentId: 'Q14',
    category: 'eye-contact-behaviors'
  },
  'Q14.2': {
    id: 'Q14.2',
    title: 'Does your child look you in the eye every day?',
    type: 'followup',
    parentId: 'Q14',
    category: 'eye-contact-followup'
  },
  'Q14.3': {
    id: 'Q14.3',
    title: 'On a day when you are together all day, does he/she look you in the eye at least 5 times?',
    type: 'followup',
    parentId: 'Q14',
    category: 'eye-contact-followup'
  },

  // Question 15
  'Q15': {
    id: 'Q15',
    title: 'Q15: Does your child try to copy what you do?',
    description: 'wave bye-bye, clap, or make a funny noise when you do)',
    type: 'main'
  },
  'Q15.1': {
    id: 'Q15.1',
    title: 'Stick out your tongue?',
    type: 'sub',
    parentId: 'Q15',
    category: 'copying-behaviors'
  },
  'Q15.2': {
    id: 'Q15.2',
    title: 'Make a funny sound?',
    type: 'sub',
    parentId: 'Q15',
    category: 'copying-behaviors'
  },
  'Q15.3': {
    id: 'Q15.3',
    title: 'Wave good bye?',
    type: 'sub',
    parentId: 'Q15',
    category: 'copying-behaviors'
  },
  'Q15.4': {
    id: 'Q15.4',
    title: 'Clap your hands?',
    type: 'sub',
    parentId: 'Q15',
    category: 'copying-behaviors'
  },
  'Q15.5': {
    id: 'Q15.5',
    title: 'Put your fingers to your lips to signal "Shhh"?',
    type: 'sub',
    parentId: 'Q15',
    category: 'copying-behaviors'
  },
  'Q15.6': {
    id: 'Q15.6',
    title: 'Blow a kiss?',
    type: 'sub',
    parentId: 'Q15',
    category: 'copying-behaviors'
  },

  // Question 16
  'Q16': {
    id: 'Q16',
    title: 'Q16: If you turn your head to look at something, does your child look around to see what you are looking at?',
    type: 'main'
  },
  'Q16.1.1': {
    id: 'Q16.1.1',
    title: 'Look toward the thing you are looking at?',
    type: 'sub',
    parentId: 'Q16',
    category: 'positive-behaviors'
  },
  'Q16.1.2': {
    id: 'Q16.1.2',
    title: 'Point toward the thing you are looking at?',
    type: 'sub',
    parentId: 'Q16',
    category: 'positive-behaviors'
  },
  'Q16.1.3': {
    id: 'Q16.1.3',
    title: 'Look around to see what you are looking at?',
    type: 'sub',
    parentId: 'Q16',
    category: 'positive-behaviors'
  },
  'Q16.2.1': {
    id: 'Q16.2.1',
    title: 'Ignore you?',
    type: 'sub',
    parentId: 'Q16',
    category: 'negative-behaviors'
  },
  'Q16.2.2': {
    id: 'Q16.2.2',
    title: 'Look at your face?',
    type: 'sub',
    parentId: 'Q16',
    category: 'negative-behaviors'
  },
  'Q16.3': {
    id: 'Q16.3',
    title: 'Which type of behaviors does your child show most often?',
    type: 'followup',
    parentId: 'Q16'
  },

  // Question 17
  'Q17': {
    id: 'Q17',
    title: 'Q17: Does your child try to get you to watch him or her?',
    description: 'does your child look at you for praise, or say "Look" or "Watch me"?',
    type: 'main'
  },
  'Q17.1': {
    id: 'Q17.1',
    title: 'Say "Look" or "Watch me"?',
    type: 'sub',
    parentId: 'Q17',
    category: 'attention-seeking-behaviors'
  },
  'Q17.2': {
    id: 'Q17.2',
    title: 'Babble or make a noise to get you to watch what he/she is doing?',
    type: 'sub',
    parentId: 'Q17',
    category: 'attention-seeking-behaviors'
  },
  'Q17.3': {
    id: 'Q17.3',
    title: 'Look at you to get praise or comment?',
    type: 'sub',
    parentId: 'Q17',
    category: 'attention-seeking-behaviors'
  },
  'Q17.4': {
    id: 'Q17.4',
    title: 'Keep looking to see if you are looking?',
    type: 'sub',
    parentId: 'Q17',
    category: 'attention-seeking-behaviors'
  },

  // Question 18
  'Q18': {
    id: 'Q18',
    title: 'Q18: Does your child understand when you tell him or her to do something?',
    description: 'if you don\'t point, can your child understand "put the book on the chair" or "bring me the blanket"?)',
    type: 'main'
  },
  'Q18.1': {
    id: 'Q18.1',
    title: 'When the situation gives him/her a clue, can he/she follow a command? For example when you are dressed to go out and you tell him/her to get his/her shoes, does he/she understand?',
    type: 'sub',
    parentId: 'Q18',
    category: 'command-understanding-with-clues'
  },
  'Q18.2': {
    id: 'Q18.2',
    title: 'If it is dinnertime and food is on the table, and you tell the child to sit down, will he/she come sit at the table?',
    type: 'sub',
    parentId: 'Q18',
    category: 'command-understanding-with-clues'
  },
  'Q18.3.1': {
    id: 'Q18.3.1',
    title: 'If you say, "Show me your shoe" without pointing, making gestures, or giving hints (when you are not going out or getting dressed), does your child show you his/her shoe?',
    type: 'followup',
    parentId: 'Q18',
    category: 'command-understanding-without-clues'
  },
  'Q18.3.2': {
    id: 'Q18.3.2',
    title: 'If you say, "Bring me the blanket" or ask for another object without pointing, making gestures, or giving hints, does your child bring it to you?',
    type: 'followup',
    parentId: 'Q18',
    category: 'command-understanding-without-clues'
  },
  'Q18.3.3': {
    id: 'Q18.3.3',
    title: 'If you say, "Put the book on the chair" without pointing, making gestures, or giving any other hints, does your child put the book on the chair?',
    type: 'followup',
    parentId: 'Q18',
    category: 'command-understanding-without-clues'
  },

  // Question 19
  'Q19': {
    id: 'Q19',
    title: 'Q19: If something new happens, does your child look at your face to see how you feel about it?',
    description: 'if he or she hears a strange or funny noise, or sees a new toy, will he or she look at your face?',
    type: 'main'
  },
  'Q19.1': {
    id: 'Q19.1',
    title: 'If your child hears a strange or scary noise, will he/she look at you before responding?',
    type: 'sub',
    parentId: 'Q19',
    category: 'social-referencing-behaviors'
  },
  'Q19.2': {
    id: 'Q19.2',
    title: 'Does your child look at you when someone new approaches?',
    type: 'sub',
    parentId: 'Q19',
    category: 'social-referencing-behaviors'
  },
  'Q19.3': {
    id: 'Q19.3',
    title: 'Does your child look at you when he/she is faced with something unfamiliar or a little scary?',
    type: 'sub',
    parentId: 'Q19',
    category: 'social-referencing-behaviors'
  },

  // Question 20
  'Q20': {
    id: 'Q20',
    title: 'Q20: Does your child like movement activities?',
    description: 'being swung or bounced on your knee?',
    type: 'main'
  },
  'Q20.1': {
    id: 'Q20.1',
    title: 'Does he/she enjoy being bounced or swung?',
    type: 'sub',
    parentId: 'Q20',
    category: 'movement-enjoyment'
  },
  'Q20.2.1': {
    id: 'Q20.2.1',
    title: 'Laugh or smile?',
    type: 'sub',
    parentId: 'Q20',
    category: 'movement-reactions'
  },
  'Q20.2.2': {
    id: 'Q20.2.2',
    title: 'Talk or babble?',
    type: 'sub',
    parentId: 'Q20',
    category: 'movement-reactions'
  },
  'Q20.2.3': {
    id: 'Q20.2.3',
    title: 'Request more by holding out his/her arms?',
    type: 'sub',
    parentId: 'Q20',
    category: 'movement-reactions'
  }
};

// Helper function to get all questions for a specific main question
export const getQuestionsForMainQuestion = (mainQuestionId: string): QuestionMapping[] => {
  const questions: QuestionMapping[] = [];
  
  // Add main question
  if (QuestionMapping[mainQuestionId]) {
    questions.push(QuestionMapping[mainQuestionId]);
  }
  
  // Add all sub-questions and follow-ups
  Object.values(QuestionMapping).forEach(question => {
    if (question.parentId === mainQuestionId) {
      questions.push(question);
    }
  });
  
  return questions.sort((a, b) => a.id.localeCompare(b.id));
};

// Helper function to get main questions only
export const getMainQuestions = (): QuestionMapping[] => {
  return Object.values(QuestionMapping).filter(q => q.type === 'main');
};
